import $ from 'jquery';

export default (container = document) => {
  $('[data-rte-collection-carousel-headings]', container).each((i, headings) => {
    const $headings = $(headings);
    $headings.find('[data-preheading]').addClass('Section__preheading');
    $headings.find('[data-heading]').addClass('Section__heading');
    $headings.css({
      display: 'block',
    });
  });
};